import axios, { AxiosRequestConfig, AxiosError } from "axios";

type HttpRequest = {
    url: string,
    method?: "get" | "post" | "put" | "delete" | "GET" | "POST" | "PUT" | "DELETE",
    auth?: boolean,
    body?: any,
    params?: any,
    token?: string
};

export default class BaseService {
    static async perform<T>(request: HttpRequest): Promise<T> {
        try {
            const config: AxiosRequestConfig = {
                baseURL: process.env.VUE_APP_HOST + "/api",
                url: request.url,
                method: request.method,
                headers: {
                    "Content-Type": "application/json"
                },
                data: request.body,
                params: request.params
            };

            if (request.auth && config.headers !== undefined) {
                config.headers["Authorization"] = `Basic ${request.token ?? sessionStorage.getItem("access-token")}`;
            }

            return (await axios(config)).data as T;
        } catch (error) {
            if (error instanceof AxiosError && error.response?.data !== undefined && error.response?.data.message !== undefined) {
                throw (error as AxiosError).response?.data;
            } else {
                throw error;
            }
        }
    }
}
